import {BaseDTO} from '../../../common/models/BaseDTO';

export class DiagnosisGroupDTO extends BaseDTO {
  constructor(diagnosisGroupId: number, code: string, name: string) {
    super();
    this.diagnosisGroupId = diagnosisGroupId;
    this.code = code;
    this.name = name;
  }
  diagnosisGroupId: number;
  code: string;
  name: string;
}
